import React from 'react';
import { ConstructorTrans } from '../utils/translations';
import { useAppContext } from '../context/AppContext';

const TagList = ({ tags, selectedTags, setSelectedTags }) => {
  const { language } = useAppContext();

  const handleTagClick = (tagId) => {
    if (selectedTags.includes(tagId)) {
      // Remove tag if it's already selected
      setSelectedTags(selectedTags.filter((selectedTag) => selectedTag !== tagId));
    } else {
      // Add tag if it's not selected
      setSelectedTags([...selectedTags, tagId]);
    }
  };

  return (
    <div className="mt-7">
      <div className="text-xs text-gray-800 font-semibold text-left pb-1">
        {ConstructorTrans[language].iWantToWorkOn}
      </div>
      <div className="flex flex-wrap gap-3">
        {tags.map((tag) => (
          <span
            key={tag.id}
            onClick={() => handleTagClick(tag.id)}
            className={`px-3 py-1 border rounded-full text-base mt-0 cursor-pointer ${
              selectedTags.includes(tag.id)
                ? "bg-brown text-white"
                : "bg-beige text-white"
            }`}
          >
            {tag.label}
          </span>
        ))}
      </div>
    </div>
  );
};

export default TagList;
